<template>
  <div>

    <b-row class="match-height">
      <b-col
        cols="8"
      >
        <b-card no-body>
          <b-card-header class="border-bottom">
            <h4 class="mb-0">
              Device Details
            </h4>
            <b-card-text>
              <b-button
                variant="outline-primary"
                @click="$refs.editDeviceModal.show()"
              >Edit</b-button>
            </b-card-text>
          </b-card-header>

          <b-card-body>

            <b-row class="mb-2 mt-2">

              <b-col>
                <p><b>ID</b></p>
                <kbd>{{ device.id }}</kbd>
              </b-col>

              <b-col>
                <p> <b>Name</b></p>
                <kbd>{{ device.name }}</kbd>
              </b-col>

              <b-col>
                <p> <b>Serial Number</b></p>
                <kbd>{{ device.manufacturerSerialNumber }}</kbd>
              </b-col>

            </b-row>

            <b-row class="border-bottom mb-2">
              <b-col>
                <h4>Device Model</h4>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p>
                  <b>Manufacturer</b>
                </p>
                <kbd> {{ device.deviceModel.deviceManufacturer.name }}</kbd>
              </b-col>

              <b-col>
                <p>
                  <b>Model</b>
                </p>
                <kbd>
                  {{ device.deviceModel.name }}
                </kbd>
              </b-col>

              <b-col>
                <p>
                  <b>Model Number</b>
                </p>
                <kbd>
                  {{ device.deviceModel.modelNumber }}
                </kbd>
              </b-col>
            </b-row>

            <b-row class="border-bottom mb-2 mt-2">
              <b-col>
                <h4>Network</h4>
              </b-col>
            </b-row>

            <b-row>

              <b-col>
                <p>
                  <b> Network</b>
                </p>
                <kbd>
                  {{ device.network.networkType.name }}
                </kbd>
              </b-col>

              <b-col>
                <p>
                  <b> Network Org Name</b>
                </p>
                <kbd>
                  {{ device.network.networkOrgName }}
                </kbd>
              </b-col>
            </b-row>

            <div
              v-if="device.network.networkType.identifier !== 'virtual-network'"
            >
              <b-row class="mb-2 mt-2">
                <b-col>
                  <p>
                    <b> App EUI</b>
                  </p>
                  <kbd>
                    {{ device.app_eui }}
                  </kbd>
                </b-col>

                <b-col>
                  <p>
                    <b>Dev EUI </b>
                  </p>
                  <kbd>
                    {{ device.dev_eui }}
                  </kbd>
                </b-col>

                <b-col>
                  <p>
                    <b>App Key </b>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="showAppKey ? 'EyeOffIcon' : 'EyeIcon'"
                      :class="{'is-danger': showAppKey}"
                      size="16"
                      @click="showAppKey = !showAppKey"
                    />
                  </p>
                  <kbd v-if="showAppKey">{{ device.app_key }}</kbd>
                  <kbd v-else>************</kbd>
                </b-col>
              </b-row>

              <b-row class="mb-2 mt-2">
                <b-col>
                  <p>
                    <b>Last Connected</b>
                  </p>
                  <kbd>{{ networkStatus.last_connected }}</kbd>
                </b-col>
              </b-row>
            </div>

            <b-row class="border-bottom mb-2 mt-2">
              <b-col>
                <h4>Device Relationship</h4>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p>
                  <b>Site</b>
                </p>
                <div
                  v-if="device.object && device.object.site"
                >
                  <b-button
                    size="sm"
                    pill
                    variant="warning"
                    @click="$router.push(`/site/${device.object.site.id}`)"
                  >
                    {{ device.object.site.name }}
                  </b-button>
                </div>
                <div
                  v-else
                >
                  No Site
                </div>
              </b-col>
              <b-col>
                <p>
                  <b>Object</b>
                </p>
                <div
                  v-if="device.object"
                >
                  <b-button
                    size="sm"
                    pill
                    variant="success"
                    @click="$router.push(`/object/${device.object.id}`)"
                  >
                    {{ device.object.name }}
                  </b-button>
                </div>
                <div
                  v-else
                >
                  No Object
                </div>
              </b-col>
              <b-col v-if="device.object">
                <p>
                  <b>Position On Object</b>
                </p>
                <kbd>{{ device.positionOnObject }}</kbd>
              </b-col>
            </b-row>

          </b-card-body>
        </b-card>
      </b-col>

      <b-col>
        <b-card>
          <b-img
            :src="device.deviceModel.imgLink"
            fluid
          />
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header class="border-bottom">
            <h4 class="mb-0">
              Device Sensors</h4>
          </b-card-header>

          <b-table
            :items="sensors"
            :fields="sensorFields"
          />
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      id="editDeviceModal"
      ref="editDeviceModal"
      title="Edit Device"
      ok-title="Save"
      cancel-variant="outline-primary"
      ok-variant="primary"
      @ok="updateDevice"
    >
      <b-row>
        <b-col>
          <b-form-group
            label="Device Name"
            label-for="deviceName"
          >
            <b-form-input
              v-if="'name' in device"
              id="deviceName"
              ref="deviceNameInput"
              v-model="device.name"
              required
              placeholder="Enter device name"
              :state="device.name.length > 0"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Serial Number"
            label-for="serialNumber"
          >
            <b-form-input
              id="serialNumber"
              v-model="device.manufacturerSerialNumber"
              required
              placeholder="Enter serial number"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Object"
            label-for="object"
          >
            <v-select
              id="object"
              v-model="device.objectDevicesId"
              :options="objects"
              label="name"
              :reduce="object => object.id"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-if="device.objectDevicesId"
        >
          <b-form-group
            label="Position On Object"
            label-for="positionOnObject"
          >
            <b-form-input
              id="positionOnObject"
              v-model="device.positionOnObject"
              placeholder="Enter position on object"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>

</template>

<script>
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BCardHeader,
  BCardText,
  BCardBody,
  BTable,
  BButton,
  BModal,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import * as mutations from '../../../graphql/mutations'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardText,
    BCardBody,
    BImg,
    BRow,
    BCol,
    BTable,
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
    sensors: {
      type: Array,
      required: true,
    },
    objects: {
      type: Array,
      required: true,
    },
    workspacetoken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lastActivityDateTime: '',
      networkStatus: {},
      sensorFields: [
        { key: 'name', label: 'Sensor Name', sortable: true },
        { key: 'identifier', label: 'Identifier', sortable: true },
        { key: 'description', label: 'Description', sortable: true },
        { key: 'dimension', label: 'Dimension', sortable: true },
        { key: 'unit', label: 'Unit', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
      ],

      showAppKey: false,
    }
  },
  created() {
    if (this.device.network.networkType.identifier !== 'virtual-network') {
      this.getNetworkStatus()
    }
  },
  methods: {
    async updateDevice(event) {
      if (this.device.name.length === 0) {
        this.$refs.deviceNameInput.focus()
        event.preventDefault() // prevent modal from submitting
      } else {
      // No suppport for PUT request in API
        const deviceInfo = {
          id: this.device.id,
          name: this.device.name,
          manufacturerSerialNumber: this.device.manufacturerSerialNumber,
        }

        if (this.device.positionOnObject) {
          deviceInfo.positionOnObject = this.device.positionOnObject
        } else {
          deviceInfo.positionOnObject = null
        }

        if (this.device.objectDevicesId) {
          deviceInfo.objectDevicesId = this.device.objectDevicesId
        } else {
          deviceInfo.objectDevicesId = null
          deviceInfo.positionOnObject = null
        }
        await API.graphql({
          query: mutations.updateDevice,
          variables: {
            input: deviceInfo,
          },
        }).then(response => {
          if (!response.errors) {
            this.device = response.data.updateDevice
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: `Device 
              ${this.device.name}`
              + ' updated',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          }
        })
        // refresh page
        this.$router.go()
      }
    },
    async getNetworkStatus() {
      await API.get('NetworkAPI', '/devices', {
        queryStringParameters: {
          id: this.device.id,
          network: this.device.network.networkType.identifier,
          apiKey: this.device.network.api_key,
          endpoint: this.device.network.networkType.apiEndpoint,
        },
      })
        .then(response => {
          if (this.device.network.networkType.identifier === 'prym-chirpstack') {
            const lastSeen = response.response.array[3][0] // 1705658504
            const lastSeenDate = new Date(lastSeen * 1000)
            this.networkStatus = {
              last_connected: lastSeenDate.toLocaleString(),
            }
          } else if (this.device.network.networkType.identifier !== 'prym-chirpstack') {
            this.networkStatus = response.device
            if (this.networkStatus.lastUpdated) {
              this.networkStatus.lastUpdated = new Date(`${this.networkStatus.lastUpdated} UTC`).toLocaleString()
            } else {
              this.networkStatus.lastUpdated = 'N/A'
            }
          }
        })
    },
  },
}
</script>

<style>

</style>
